<script setup>
import AppLayout from 'Modules/components/layouts/AppLayout.vue'
import AppHeader from 'Modules/AppHeader.vue'
</script>

<template>
  <AppLayout>
    <template #header-content>
      <AppHeader />
    </template>
    <template #main-content><slot>No Site Content</slot></template>
  </AppLayout>
</template>
